import React, { useEffect, useState } from 'react';

import { Grid, Typography, List, ListItem, Button, Divider, Link, Modal } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { BACKGROUND_COLOR, COLOR_PRIMARY_LIGHT, COLOR_PRIMARY_DARK } from 'src/const';
import { callApi } from 'src/core/callApi';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      minHeight: '80vh',
    },
    customButton: {
      background: COLOR_PRIMARY_DARK, //`radial-gradient(circle, hsla(189, 96%, 29%, 1) 0%, hsla(178, 100%, 38%, 1) 100%);`,
      borderRadius: 5,
      border: 70,
      color: 'white',
      height: 45,
      padding: '0 15px',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3)',
      '&:hover': {
        background: COLOR_PRIMARY_LIGHT,
      },
    },
  })
);

const BigMarkets = () => {
  const classes = useStyles();
  const [markets, setMarkets] = useState<string[] | null>(null);
  const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

  const getBigMarkets = async () => {
    const url = 'https://3lgkyxa85a.execute-api.us-east-2.amazonaws.com/default/getBigMarkets';
    const queryParamsConfig = { queryParams: { all: true } };
    try {
      const result = await callApi(url, queryParamsConfig, true);
      console.log('Res >> ', result);
      if (!Array.isArray(result?.message)) {
        setIsAuthorized(false);
        return;
      }
      setMarkets(result.message);
    } catch (err) {
      console.log('Error: ', err);
    }
  };

  useEffect(() => {
    getBigMarkets();
  }, []);

  if (!isAuthorized) {
    return (
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        spacing={4}
        style={{ padding: '40px' }}
      >
        <Typography variant="h1">Unauthorized !</Typography>
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="space-between"
      className={classes.container}
      spacing={4}
      style={{ padding: '40px' }}
    >
      <Grid item>
        <Typography variant="h5" style={{ marginBottom: 10 }}>
          Big Markets
        </Typography>
        <Divider />

        {!markets && <Typography variant="h5">Loading ...</Typography>}

        <List>
          {markets &&
            markets.map((data, idx) => (
              <ListItem key={idx + 'big_market_view'}>
                <Typography>
                  <Link
                    target="_blank"
                    style={{ textTransform: 'capitalize' }}
                    href={window.location.href + "/" + data}
                  >
                    {data}
                  </Link>
                </Typography>
              </ListItem>
            ))}
        </List>
      </Grid>
    </Grid>
  );
};

export default BigMarkets;
